import React, { useState, useEffect } from 'react';
import {
    getAllManufacturerWithProductsV2,
    getAllDistrictProducts,
    getAllDistrictProductOptionItems,
    getAllManufacturerWithProducts,
    addProduct,
    removeProduct,
    addProductLine,
    removeProductLine,
    addProductOptionItems,
    removeProductOptionItems,
} from '../../../../api/districtproductsapi';
import { getProduct } from '../../../../api/productapi';
import { AdminModal } from '../../../../components/admin/admin-modal';
import { getAllDealers, addDealer, getDealer, removeDealer } from '../../../../api/dealersApi';
import { getLoginUserDetailsV2 } from '../../../../api/adminuserapi';

import PropTypes from 'prop-types';
const ManufacturerList = ({
    districtId,
    manufacturers,
    fetchProductDetails,
    handleSelection,
    selectedProducts,
    handleBulkSelection,
    selectedAllProductOptions,
    dealerList
}) => {
    const [selectedDealers, setSelectedDealers] = useState({});

    const handleDealerChange = (e, manufacturerId) => {
        const selectedUserId = e.target.value;

        if (selectedUserId) {
            addDealer(districtId, selectedUserId, manufacturerId)
                .then((response) => {
                    if (response.data.success) {
                        return getDealer(districtId, manufacturerId);
                    }
                })
                .then((res) => {
                    if (res?.data.success) {
                        const dealerInfo = res.data.data;
                        setSelectedDealers((prev) => ({
                            ...prev,
                            [manufacturerId]: dealerInfo,
                        }));
                    }
                })
                .catch((error) => {
                    console.error("Dealer update failed", error);
                });
        } else {
            removeDealer(districtId, manufacturerId)
                .then((response) => {
                    if (response.data.success) {
                        setSelectedDealers((prev) => ({
                            ...prev,
                            [manufacturerId]: null,
                        }));
                    }
                })
                .catch((error) => {
                    console.error("Dealer removal failed", error);
                });
        }
    };

    return (
        <div>
            {manufacturers &&
                manufacturers.map((manufacturer) => {
                    return (
                        <div key={manufacturer.id} className="admin-product-checkbox-section">
                            <div className="manufacturer-section-header">
                                <h2 className="manufacturer-section-headline">{manufacturer.name}</h2>
                                <select className="admin-default-select manufacturer-select" value={selectedDealers[manufacturer.id] !== undefined ? selectedDealers[manufacturer.id]?.dealerId || ""  : manufacturer?.dealer?.dealerId || ""} onChange={(e) => handleDealerChange(e, manufacturer.id)} >
                                    <option value="">Select a Dealer</option>
                                    {dealerList?.map((dealer) => (
                                        <option key={dealer.siteUserId} value={dealer.siteUserId}>
                                            {`${dealer.siteUsers?.fullName} (${dealer.siteUsers?.organization})`}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="admin-column-wrap allow-wrapping">
                                {manufacturer.productLines.filter(a => a.products.length > 0).map((productLine) => {
                                    var hasAllProducts = productLine.products.filter(a => selectedProducts.filter(b => a.id == b).length > 0).length == productLine.products.length;
                                    return (
                                        <div key={productLine.id} className="admin-column">
                                            <p className="admin-section-small-headline">
                                                {productLine.name}
                                            </p>
                                            <label
                                                className="admin-inline-label"
                                                htmlFor={`bulk-${productLine.id}`}
                                            >
                                                <input
                                                    className="admin-inline-checkbox"
                                                    id={`bulk-${productLine.id}`}
                                                    type="checkbox"
                                                    checked={hasAllProducts}
                                                    onChange={() => {
                                                        if (!hasAllProducts) {
                                                            addProductLine(districtId, productLine.id)
                                                        } else {
                                                            removeProductLine(districtId, productLine.id)
                                                        }
                                                        handleBulkSelection(
                                                            productLine.id,
                                                            productLine.products,
                                                            !hasAllProducts
                                                        );
                                                    }}
                                                />
                                                {/*<span className="checkmark"></span>*/}
                                                <span className="admin-inline-label-text">
                                                    {hasAllProducts
                                                        ? 'Clear All'
                                                        : 'Select All'}
                                                </span>
                                            </label>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    border: '0.50px #D9D9D9 solid',
                                                }}
                                            ></div>

                                            {productLine.products &&
                                                productLine.products.map((product) => {
                                                    const productOptionItems = product.optionItems.length;
                                                    const selectedOptionItems = product.optionItems && product.optionItems.length > 0 ? selectedAllProductOptions.filter(a => product.optionItems.filter(b => b == a).length > 0).length : 0;
                                                    let selected = selectedProducts.filter(a => a == product.id).length > 0;
                                                    if ((!selected && selectedOptionItems == 0) && productOptionItems > 0) {
                                                        selected = false;
                                                    }
                                                    return (
                                                        <span className={'admin-inline-label' + (productOptionItems > selectedOptionItems && selectedOptionItems > 0 ? ' ind-dash' : '')} key={product.id}>
                                                            <input
                                                                className="admin-inline-checkbox"
                                                                id={product.id}
                                                                type="checkbox"
                                                                checked={selected}
                                                                value={product.name}
                                                                onChange={handleSelection}
                                                                onClick={(e) => e.stopPropagation()}
                                                            />
                                                            {/*<span className="checkmark"></span>*/}
                                                            <span className="admin-inline-label-text product-label"
                                                                onClick={() => fetchProductDetails(product.id)}
                                                            >
                                                                {product.productTitle}
                                                                {productOptionItems > 0 && selected ?
                                                                    <span className="total-items">({selectedOptionItems}/{productOptionItems})</span>
                                                                    : <></>
                                                                }
                                                            </span>
                                                        </span>
                                                    )
                                                })}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
        </div >
    );
};

ManufacturerList.propTypes = {
    districtId: PropTypes.number,
    manufacturers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            productLines: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    name: PropTypes.string.isRequired,
                    products: PropTypes.arrayOf(
                        PropTypes.shape({
                            id: PropTypes.number.isRequired,
                            productTitle: PropTypes.string.isRequired,
                            name: PropTypes.string,
                        })
                    ),
                })
            ),
        })
    ),
    fetchProductDetails: PropTypes.func.isRequired,
    handleSelection: PropTypes.func.isRequired,
    selectedProducts: PropTypes.array.isRequired,
    handleBulkSelection: PropTypes.func,
    selectedAllProductOptions: PropTypes.array,
    dealerList: PropTypes.array,
};

export default function DistrictProducts({ districtId }) {
    const [manufacturers, setManufacturers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [viewProduct, setViewProduct] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [selectedAllProductOptions, setSelectedAllProductOptions] = useState([]);
    const [deselectedOptions, setDeselectedOptions] = useState([]);
    const [dealerList, setDealerList] = useState([]);
    const [distictUserRoles, setDistictUserRoles] = useState(null);

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const userResponse = await getLoginUserDetailsV2();
                if (userResponse?.data?.success === true) {
                    setDistictUserRoles(userResponse.data);
                }
            } catch (error) {
                console.error("Failed to fetch login user details", error);
            }
        };

        fetchUserDetails();
    }, []);

    useEffect(() => {
        getAllDistrictProducts(districtId)
            .then((response) => {
                const selectedProductIds = response.data.data.map(
                    (product) => {
                        return product.productId
                    }
                );
                setSelectedProducts(selectedProductIds);

                getAllDistrictProductOptionItems(districtId)
                    .then((response2) => {
                        setSelectedAllProductOptions(response2.data.data);
                    })
                    .catch((err) => {
                        console.error('Error fetching district product option items:', err);
                        setError(err);
                    });

            })
            .catch((err) => {
                console.error('Error fetching district products:', err);
                setError(err);
            });
        getAllDealers(districtId)
            .then((response) => {
                setDealerList(response.data.data);
            })
            .catch((err) => {
                console.error('Error fetching dealers:', err);
                setError(err);
            })
            .finally(() => {
                setLoading(false);
            });

        //new getting getAllManufacturerWithProducts API cal
        getAllManufacturerWithProductsV2(districtId)
            .then((response) => {
                setManufacturers(response.data.data);
            })
            .catch((err) => {
                console.error('Error fetching manufacturers:', err);
                setError(err);
            })
            .finally(() => {
                setLoading(false);
            });
        //old getting getAllManufacturerWithProducts API call
        getAllManufacturerWithProducts()
            .then((response) => {
                console.log("getAllManufacturerWithProducts ", response.data.data);
                //setManufacturers(response.data.data);
            })
            .catch((err) => {
                console.error('Error fetching manufacturers:', err);
                setError(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [districtId]);

    const fetchProductDetails = (productId) => {
        getProduct(productId)
            .then((response) => {
                let product = response.data.data;
                setViewProduct(product);
                var options = product.options ? product.options.filter(a => a.items != null && a.items.length > 0).map(a => a.items) : [];
                var optionItems = [];
                options.forEach(a => optionItems.push(...a));
                var selectedItems = selectedAllProductOptions.filter(a => optionItems.filter(b => b.id == a).length > 0);
                setSelectedProductOptions(selectedItems);
                if (selectedProducts.filter(a => a == productId).length == 0) {
                    addProduct(districtId, productId);
                    setSelectedProducts((prev) => [...prev, productId]);
                }
                setShowModal(options && options.length > 0);

            })
            .catch((err) => {
                console.error('Error fetching district products:', err);
                setError(err);
            });
    };
    const onClose = () => {
        setShowModal(false);
    };
    const handleViewedProductSave = () => {
        addProductOptionItems(districtId, selectedProductOptions.filter(a => a != null));
        if (deselectedOptions && deselectedOptions?.length > 0) {
            removeProductOptionItems(districtId, deselectedOptions);
            setDeselectedOptions([]);
        }

        //if (!selectedProductOptions?.length) {
        //    removeProduct(districtId, viewProduct?.id);
        //}

        setShowModal(false);
    };

    const handleSelection = (event, bulkUpdates = []) => {
        if (bulkUpdates.length) {
            setSelectedProducts(bulkUpdates);
        } else {
            const productId = parseInt(event.target.id);
            if (selectedProducts.includes(productId)) {
                removeProduct(districtId, productId);
                setSelectedProducts((prev) => prev.filter((id) => id !== productId));
            } else {
                addProduct(districtId, productId);
                setSelectedProducts((prev) => [...prev, productId]);
            }
        }
    };

    const handleBulkSelection = (productLineId, products, shouldSelect) => {
        if (shouldSelect) {
            const newSelections = products.map((product) => product.id);
            //select product options where no options for a given product were previously selected
            var productLine = [...manufacturers.map(a => a.productLines).reduce((a, b) => [...a, ...b])].filter(a => a.id == productLineId)[0];
            var optionItems = productLine.products ? productLine.products.filter(a => (a.optionItems && a.optionItems.length > 0 &&
                a.optionItems.filter(b => selectedAllProductOptions.filter(c => c == b).length > 0).length == 0)
                || !a.optionItems || a.optionItems.length == 0
            ).map(a => a.optionItems) : [];
            if (optionItems.length > 0) {
                var options = [...optionItems.reduce((a, b) => [...a, ...b])];
                handleBulkOptionsSelection(options, true);
            }
            //select products
            handleSelection(null, [...selectedProducts, ...newSelections]);
        } else {
            const idsToRemove = products.map((product) => product.id);
            const updatedSelections = selectedProducts.filter(
                (id) => !idsToRemove.includes(id)
            );
            setSelectedProducts(updatedSelections);
        }
    };

    const handleProductOptionsSelection = (event) => {
        const itemId = parseInt(event.target.id.replace('optionitem', ''));
        if (selectedProductOptions.includes(itemId)) {
            setSelectedProductOptions((prev) =>
                prev.filter((id) => id !== itemId)
            );
            setSelectedAllProductOptions((prev) =>
                prev.filter((id) => id !== itemId)
            );
            setDeselectedOptions((prev) => [...prev, itemId]);
        } else {
            setSelectedProductOptions((prev) => [...prev, itemId]);
            setSelectedAllProductOptions((prev) => [...prev, itemId]);
            setDeselectedOptions((prev) => prev.filter((id) => id !== itemId));
        }
    };

    const handleBulkOptionsSelection = (itemIds, shouldSelect) => {
        setSelectedProductOptions(selectedProductOptions.filter((id) => !itemIds.includes(id)));
        setSelectedAllProductOptions((prev) =>
            prev.filter((id) => itemIds.filter(a => a == id).length == 0)
        );
        if (shouldSelect) {
            setSelectedProductOptions((prev) => [...prev, ...itemIds]);
            setSelectedAllProductOptions((prev) => [...prev, ...itemIds]);
            setDeselectedOptions((prev) => prev.filter((id) => !itemIds.includes(id)));
        } else {
            setDeselectedOptions((prev) => [...new Set([...prev, ...itemIds])]);
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
    return (
        <div
            className="admin-tab-content"
            style={
                !distictUserRoles?.isDistrictAdmin ? {
                    pointerEvents: distictUserRoles?.data?.isDistrictAdmin ? 'none' : 'auto',
                    opacity: distictUserRoles?.data?.isDistrictAdmin ? 0.6 : 1,
                }
                    : {}
            }
        >

            <ManufacturerList
                districtId={Number(districtId)}
                manufacturers={manufacturers}
                fetchProductDetails={fetchProductDetails}
                handleSelection={handleSelection}
                selectedProducts={selectedProducts}
                handleBulkSelection={handleBulkSelection}
                selectedAllProductOptions={selectedAllProductOptions}
                dealerList={dealerList}
            />
            <AdminModal
                show={showModal}
                onClose={onClose}
                onSave={handleViewedProductSave}
                modalTitle={viewProduct.details ? viewProduct.details.name : ''}
                adminModalClass="large grow"
            >
                {viewProduct &&
                    viewProduct.options &&
                    viewProduct.options.length === 0 ? (
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell full">
                            <p>No options selected.</p>
                        </div>
                    </div>
                ) : (
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell full">
                            <div className="admin-column-wrap allow-wrapping">
                                {viewProduct &&
                                    viewProduct.options &&
                                    viewProduct.options.filter(a => a.items && a.items.length > 0).map((option) => {
                                        const selectedAll = selectedAllProductOptions.filter(a => option.items.filter(b => b.id == a).length > 0).length == option.items.length;
                                        return (
                                            <div key={option.id} className="admin-column">
                                                <p className="admin-section-small-headline">
                                                    {option.title}
                                                </p>
                                                <label
                                                    className="admin-inline-label"
                                                    htmlFor={`bulk-${option.id}`}
                                                >
                                                    <input
                                                        className="admin-inline-checkbox"
                                                        id={`bulk-${option.id}`}
                                                        type="checkbox"
                                                        checked={selectedAll}
                                                        onChange={() =>
                                                            handleBulkOptionsSelection(
                                                                option.items.map((item) => item.id),
                                                                !selectedAll
                                                            )
                                                        }
                                                    />
                                                    <span className="admin-inline-label-text">
                                                        {selectedAll
                                                            ? 'Clear All'
                                                            : 'Select All'}
                                                    </span>
                                                </label>
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        border: '0.50px #D9D9D9 solid',
                                                    }}
                                                ></div>
                                                {option.items &&
                                                    option.items.map((item) => (

                                                        <label
                                                            className="admin-inline-label"
                                                            htmlFor={'optionitem' + item.id}
                                                            key={'optionitem' + item.id}
                                                        >
                                                            <input
                                                                className="admin-inline-checkbox"
                                                                id={'optionitem' + item.id}
                                                                type="checkbox"
                                                                value={item.name}
                                                                checked={selectedAllProductOptions.includes(item.id)}
                                                                onChange={handleProductOptionsSelection}
                                                            />
                                                            <span className="admin-inline-label-text">
                                                                {option.type == 2 && item.color ? item.color.name : item.title}
                                                            </span>
                                                        </label>
                                                    ))}
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                )}
            </AdminModal>
        </div>
    );
}

DistrictProducts.propTypes = {
    districtId: PropTypes.string,
};
